/** @format */

import axiosNotification from '@/plugins/axiosNotification';
import { snackBarError, snackBarSuccess } from '@/utils/snackbar';

export default {
	async saveToken({ commit }, code) {
		try {
			const { data } = await axiosNotification(`/calendar/success`, {
				method: 'POST',
				data: { code },
			});
			localStorage.setItem('calendarToken', JSON.stringify(data.token));
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
	async syncPlace({ commit }, { place }) {
		try {
			const { data } = await axiosNotification(`/calendar/sync-place`, {
				method: 'POST',
				data: { place },
			});
			snackBarSuccess(data.message)(commit);
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
	async login({ commit }) {
		try {
			const { data } = await axiosNotification(`/calendar/auth-url`, {
				method: 'GET',
			});
			snackBarSuccess(data.message)(commit);
			return data.url;
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
};
